module.exports = __webpack_public_path__ + "img/yslp.4bc43ef1.png";